import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import cN from 'classnames';
import { RootState } from '@Redux/detail/store';
import { setGroupDetailSync } from '@Redux/detail/Group/actions';
import { useMediaQuery } from 'react-responsive';
// import Tags from './subComponents/Tags';
import Tags from '@components/Common/Tags';
import Spinner from '@components/Common/Spinner';
import Register from './subComponents/Register';
import Info from './subComponents/Info';
import styles from './style.module.scss';
import SellDate from '../GroupTripInfo/subComponents/SellDate';

const GroupDetail = () => {
    const { GroupInfo, isLoading } = useSelector((store: RootState) => store.groupReducer);
    const dispatch = useDispatch();
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });

    useEffect(() => {
        const { travelinfo } = document.getElementById('detailPagePara')!.dataset!;
        dispatch(setGroupDetailSync({ ...JSON.parse(travelinfo!), isLoading: false }));
    }, [dispatch]);

    return !!GroupInfo && !isLoading ? (
        <div className={cN(styles['group_detail'], 'group_detail')}>
            {!!GroupInfo.TourBuName && (
                <div className={styles.bu}>出團旅行社:{GroupInfo.TourBuName}</div>
            )}
            <h1 className={styles.title}>{GroupInfo.TourName}</h1>
            <Tags
                IsVip={GroupInfo.IsVip}
                TripTypeList={GroupInfo.TripTypeList}
                TagList={GroupInfo.TagList}
                isOnlyMobileHide={true}
                isToggleLightBox={true}
            />
            <Info />
            <Register />
            {isMobile && <SellDate />}
        </div>
    ) : (
        <Spinner />
    );
};

export default React.memo(GroupDetail);
